module.exports = __webpack_public_path__ + "img/register.bbfe0fe4.jpg";